"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTd = exports.DateDiv = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = require("@atlaskit/theme");

/* eslint no-confusing-arrow: 0 */
var getTransparent = (0, _theme.themed)({
  light: 'transparent',
  dark: 'transparent'
});
var selectedBackground = (0, _theme.themed)({
  light: _theme.colors.N500,
  dark: _theme.colors.N0
});
var prevSelectedBackground = (0, _theme.themed)({
  light: _theme.colors.B50,
  dark: _theme.colors.B50
});
var textDisabled = (0, _theme.themed)({
  light: _theme.colors.N40,
  dark: _theme.colors.N40
});
var textHoverSelected = (0, _theme.themed)({
  light: _theme.colors.N600,
  dark: _theme.colors.N600
});
var textPreviouslySelected = (0, _theme.themed)({
  light: _theme.colors.N600,
  dark: _theme.colors.N600
});
var textSelected = (0, _theme.themed)({
  light: _theme.colors.N0,
  dark: _theme.colors.N700
});
var textSibling = (0, _theme.themed)({
  light: _theme.colors.N200,
  dark: _theme.colors.N200
});
var hoverPreviouslySelectedBackground = (0, _theme.themed)({
  light: _theme.colors.B50,
  dark: _theme.colors.B50
});
var isActiveBackground = (0, _theme.themed)({
  light: _theme.colors.B50,
  dark: _theme.colors.B50
});
var hoverBackground = (0, _theme.themed)({
  light: _theme.colors.N30,
  dark: _theme.colors.N800
});
var getBackgroundColorSelectedAfter = (0, _theme.themed)({
  light: _theme.colors.N700,
  dark: _theme.colors.N700
});

var getBackgroundColorsAfter = function getBackgroundColorsAfter(props) {
  return props.selected ? getBackgroundColorSelectedAfter(props) : _theme.colors.primary(props);
};

var getBorderColorFocused = (0, _theme.themed)({
  light: _theme.colors.B100,
  dark: _theme.colors.B75
});

var getBorderColors = function getBorderColors(props) {
  return props.focused ? getBorderColorFocused(props) : getTransparent(props);
};

function getBackgroundColor(props) {
  if (props.selected) return selectedBackground(props);
  if (props.previouslySelected) return prevSelectedBackground(props);
  return getTransparent(props);
}

function getColor(props) {
  if (props.disabled) return textDisabled(props);
  if (props.selected) return textSelected(props);
  if (props.previouslySelected) return textPreviouslySelected(props);
  if (props.isToday) return _theme.colors.primary(props);
  if (props.sibling) return textSibling(props);
  return _theme.colors.text(props);
}

var getCursor = function getCursor(_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
};

function getHoverBackgroundColor(props) {
  if (props.disabled) return getTransparent(props);
  if (props.previouslySelected) return hoverPreviouslySelectedBackground(props);
  if (props.isActive) return isActiveBackground(props);
  return hoverBackground(props);
}

var getHoverColor = function getHoverColor(props) {
  if (props.sibling) return textSibling(props);
  if (props.disabled) return textDisabled(props);
  if (props.selected || props.previouslySelected || props.isActive) return textHoverSelected(props);
  return _theme.colors.text(props);
};

var DateDiv = _styledComponents.default.div.withConfig({
  displayName: "Date__DateDiv",
  componentId: "sc-1h7o82l-0"
})(["\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: 3px;\n  color: ", ";\n  cursor: ", ";\n  font-size: 14px;\n  padding: 4px 9px;\n  position: relative;\n  text-align: center;\n\n  ", " &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"], getBackgroundColor, getBorderColors, getColor, getCursor, function (props) {
  return props.isToday ? (0, _styledComponents.css)(["\n          font-weight: bold;\n          &::after {\n            background-color: ", ";\n            bottom: 2px;\n            content: '';\n            display: block;\n            height: 2px;\n            left: 2px;\n            position: absolute;\n            right: 2px;\n          }\n        "], getBackgroundColorsAfter(props)) : '';
}, getHoverBackgroundColor, getHoverColor);

exports.DateDiv = DateDiv;

var DateTd = _styledComponents.default.td.withConfig({
  displayName: "Date__DateTd",
  componentId: "sc-1h7o82l-1"
})(["\n  border: 0;\n  padding: 0;\n  text-align: center;\n"]);

exports.DateTd = DateTd;